import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import InfiniteScroll from "react-infinite-scroller";
import { makeSelectCurrentUserToken, makeSelectCurrentSite } from "../App/selectors";
import { sendAnalyticsEvent } from "../../utils/helpers";
import Loader from "./loader";
import FeedWelcome from "./FeedWelcome";
import { BASIC_STORIES, STREAM_COMPONENTS } from "./constants";
import { alternatePostsAndStories, randomizeStories } from "./helpers";

const Stream = () => {
  const [hasMore, setHasMore] = useState(true);
  const [showWelcome, setShowWelcome] = useState(false);
  const [stories, setStories] = useState([]);
  const recommendedContent = randomizeStories(BASIC_STORIES);

  const fetchMoreData = (page = 1) => {
    if (!hasMore) {
      return;
    }

    Notifications.getNotifications(page).then(response => {
      if (window.adInsights) { window.adInsights.e("myad-feed", "next-page", page); }
      let newNotifications = response.notifications;
      if (page === 1) {
        newNotifications = alternatePostsAndStories(recommendedContent, newNotifications, 4);
      }

      setStories(prevStories => prevStories.concat(newNotifications));
      setHasMore(!response.pagination.last_page);
      sendAnalyticsEvent({ type: "scroll" });
    });
  };

  useEffect(() => {
    MyAD.renderBookmarkLinks();

    if (localStorage.getItem("feed_welcome") === null) {
      MyAD.checkTour("feed_welcome", null, data => {
        if (data.status !== "show") {
          localStorage.setItem("feed_welcome", "done");
          return;
        }

        setShowWelcome(true);
        if (window.adInsights) {
          window.adInsights.e("onboarding", "show", "feed_welcome");
        }
      });
    }
  }, []);

  const renderStories = useCallback(() => {
    return stories.map((story, index) => {
      const StreamComponent = STREAM_COMPONENTS[story.trigger];
      if (!StreamComponent) { return null; }

      return <StreamComponent key={`${story.trigger}-${index}`} story={story} type={story.type} />;
    });
  }, [stories]);

  return (
    <div className="myarchdaily-stream-wrapper">
      {showWelcome && <FeedWelcome />}
      <InfiniteScroll
        loadMore={fetchMoreData}
        hasMore={hasMore}
        loader={<Loader items="2" type="Feed" key={0} />}
        className="myad-main-feed"
      >
        {renderStories()}
      </InfiniteScroll>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  token: makeSelectCurrentUserToken(),
  site: makeSelectCurrentSite()
});

export default connect(mapStateToProps)(Stream);
